import { addressValidationSchema } from '../AddressCreate/AddressCreate.validations'

export const addressUpdateValidationSchema = addressValidationSchema.shape({})
